<div class="card d-block d-sm-none">
<div class="d-flex flex-row justify-content-start">

    <div class="item">
        <button mat-mini-fab [matBadge]="dotaznikyCount > 0 ? dotaznikyCount : ''"
                matBadgeColor="warn" [color]="dotaznikyShow ? 'primary' : 'link'" (click)="onDotaznikyClick()">
            <mat-icon>ballot</mat-icon>
        </button>
    </div>

    <div class="item">
        <button mat-mini-fab [matBadge]="diskusiaCount > 0 ? diskusiaCount : ''"
                matBadgeColor="warn" [color]="diskusiaShow ? 'primary' : 'link'" (click)="onDiskusiaClick()">
            <mat-icon>question_answer</mat-icon>
        </button>
    </div>

    <div class="item">
        <button mat-mini-fab [matBadge]="poplatkyCount > 0 ? poplatkyCount : ''"
                matBadgeColor="warn" [color]="poplatkyShow ? 'primary' : 'link'" (click)="onPoplatkyClick()">
            <mat-icon>euro_symbol</mat-icon>
        </button>
    </div>

    <div class="item">
        <button mat-mini-fab [matBadge]="messageCount > 0 ? messageCount : ''"
                matBadgeColor="warn" [color]="messagesShow ? 'primary' : 'link'" (click)="onMessagesClick()">
            <mat-icon>notifications_none</mat-icon>
        </button>
    </div>

    <div class="item">
        <button mat-mini-fab [matBadge]="jobMarketCount > 0 ? jobMarketCount : ''"
                matBadgeColor="warn" [color]="jobMarketShow ? 'primary' : 'link'" (click)="onJobMarketClick()">
            <mat-icon>work_outline</mat-icon>
        </button>
    </div>

</div>
</div>
